(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('variant:update', event => {
    const source = event.detail?.data?.html;
    const scope = event.target.closest('.product-information');
    if (!source || !scope) return;
    for (const selector of ['[data-axd-model-colors]', '.axd-pdp-extras']) {
      const current = scope.querySelector(selector);
      const replacement = source.querySelector(selector);
      if (current && replacement) current.replaceWith(replacement);
    }
  });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-axd-model-index]');
    if (!trigger) return;
    const gallery = trigger.closest('media-gallery');
    if (!gallery) return;
    event.preventDefault();
    await customElements.whenDefined('media-gallery');
    const index = Number(trigger.dataset.axdModelIndex);
    if (window.matchMedia('(max-width: 749px)').matches) {
      gallery.slideshow?.select(index, undefined, { animate: !reducedMotion() });
      gallery.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'instant' : 'smooth' });
    } else {
      gallery.zoom(index, event);
    }
  }, { capture: true });
  const form = document.querySelector('[data-axdr-collection-filters]');
  const grid = document.querySelector('.axdr-collection-products');
  if (form && grid) {
    const color = form.querySelector('[data-axd-color-filter]');
    const fit = form.querySelector('[data-axd-fit-filter]');
    const material = form.querySelector('[data-axd-material-filter]');
    const minimum = form.querySelector('[data-axd-min-price]');
    const maximum = form.querySelector('[data-axd-max-price]');
    const controls = form.querySelector('[data-axd-custom-filters]');
    const parameters = new URL(location.href).searchParams;
    const selects = [[color, 'axd_color'], [fit, 'axd_fit'], [material, 'axd_material']];
    for (const [select, name] of selects) {
      if (!select) continue;
      select.disabled = false;
      const value = (parameters.get(name) || '').slice(0, 80);
      if (value && !Array.from(select.options).some(option => option.value === value)) {
        select.add(new Option(value, value));
      }
      select.value = value;
    }
    const priceControls = [[minimum, 'axd_min_price'], [maximum, 'axd_max_price']];
    for (const [input, name] of priceControls) {
      if (!input) continue;
      input.disabled = false;
      const value = parameters.get(name);
      if (value && Number.isFinite(Number(value)) && Number(value) >= 0) input.value = String(Number(value));
    }
    if (controls) controls.hidden = false;
    const refreshOptions = () => {
      for (const [select, key, labelKey] of [[color, 'axdColor', 'axdColorLabel'], [fit, 'axdFit', 'axdFitLabel']]) {
        if (!select) continue;
        for (const card of grid.querySelectorAll(':scope > .axdr-card')) {
          const value = card.dataset[key];
          if (value && !Array.from(select.options).some(option => option.value === value)) select.add(new Option(card.dataset[labelKey] || value, value));
        }
      }
    };
    const refreshMaterials = () => {
      if (!material) return;
      const available = new Set(Array.from(grid.querySelectorAll(':scope > .axdr-card')).flatMap(card => (card.dataset.axdMaterial || '').split('|')));
      for (const option of material.options) option.hidden = !!option.value && !available.has(option.value) && option.value !== material.value;
    };
    const apply = () => {
      refreshOptions();
      refreshMaterials();
      const cards = Array.from(grid.querySelectorAll(':scope > .axdr-card'));
      let count = 0;
      for (const card of cards) {
        const match = (!color?.value || card.dataset.axdColor === color.value) && (!fit?.value || card.dataset.axdFit === fit.value) && (!material?.value || (card.dataset.axdMaterial || '').split('|').includes(material.value)) && (!minimum?.value || Number(card.dataset.axdrPrice) >= Number(minimum.value) * 100) && (!maximum?.value || Number(card.dataset.axdrPrice) <= Number(maximum.value) * 100);
        card.hidden = !match;
        if (match) count++;
      }
      const label = document.querySelector('[data-axdr-available-count]');
      if (label) {
        const suffix = label.dataset.axdCountSuffix ? ' ' + label.dataset.axdCountSuffix : document.documentElement.lang === 'hu' ? ' elérhető termék' : document.documentElement.lang === 'en' ? ' products available' : ' produse disponibile';
        label.textContent = document.documentElement.lang === 'ro' && count === 1 ? '1 produs disponibil' : count + suffix;
      }
      const empty = document.querySelector('[data-axd-filter-empty]');
      const loading = document.querySelector('[data-axdr-collection-next]:not([hidden])');
      if (empty) empty.hidden = count > 0 || !!loading || (!color?.value && !fit?.value && !material?.value && !minimum?.value && !maximum?.value);
    };
    for (const [select, name] of selects) {
      select?.addEventListener('change', () => {
        const url = new URL(location.href);
        if (select.value) url.searchParams.set(name, select.value);
        else url.searchParams.delete(name);
        history.replaceState({}, '', url);
        apply();
      });
    }
    for (const [input, name] of priceControls) {
      input?.addEventListener('input', () => {
        const url = new URL(location.href);
        if (input.value) url.searchParams.set(name, input.value);
        else url.searchParams.delete(name);
        history.replaceState({}, '', url);
        apply();
      });
    }
    document.addEventListener('axd:collection-updated', apply);
    apply();
  }
})();
